
interface User {
    email: string;
    id: string;
    permissions: string[];
}

export const useAuth = () => {
    const userSession = useState('user-session', (): null | { user: User } => null)

    const fetchSession = async (): Promise<{ user: User } | null> => {
        const result = await $fetch<ApiResponse<User | { user: null }>>('/api/auth/user/session', {
            method: 'get',
            headers: import.meta.server ? useRequestHeaders(['cookie']) : undefined
        })
        if (!result.success) throw result.message
        // Signed out, the endpoint answers `{ user: null }` instead of a user.
        userSession.value = 'id' in result.data ? { user: result.data } : null
        return userSession.value
    }

    const clearSession = () => {
        userSession.value = null
    }

    const logout = async () => {
        // await useFetch('/api/auth/logout', { method: 'GET' })
        await $fetch('/api/auth/logout', { method: 'GET', credentials: 'include' })
        useUserStore().$reset()
        clearSession()
        await nextTick()
        await navigateTo('/login')
    }

    return {
        session: userSession,
        fetchSession,
        clearSession,
        logout
    }
}